import { Capacitor } from "@capacitor/core";
import { Filesystem, Directory } from "@capacitor/filesystem";
import { toPng } from "html-to-image";
import { fileSaved, fileSaveError, shareBase64 } from "./apputil";
import { AlertProps, TransitionType } from "@/components/layout/layoutType";
import dayjs from "dayjs";
import { RefObject } from "react";
// import dynamic from "next/dynamic";
// const toPng = dynamic(() => import("html-to-image").then((mod) => mod.), { ssr: false });
export const exportChartAsPNG = (
  ta: TransitionType,
  alertContext: AlertProps | undefined,
  layoutRef: HTMLDivElement | null,
  defaultName: string,
  fileName: boolean | string | undefined,
) => {
  if (layoutRef) {
    const el = layoutRef.querySelector("div:has(>svg) svg") as HTMLElement;
    exportElementAsPNGDefault(ta, alertContext, el, defaultName, fileName);
  }
};
export const exportElementAsPNGDefault = (
  ta: TransitionType,
  alertContext: AlertProps | undefined,
  el: HTMLElement | string,
  defaultName: string,
  fileName: boolean | string | undefined,
) => {
  const check_el = typeof el === "string" ? (document.querySelector(el) as HTMLElement) : el;
  if (check_el) {
    check_el.classList.add("Download");
    exportElementAsPNG(
      ta,
      check_el,
      (typeof fileName === "string" ? fileName : defaultName) + "_" + dayjs().format("YYYYMMDDHHmmss"),
      () => {
        check_el.classList.remove("Download");
      },
      fileSaved(alertContext, ta),
      fileSaveError(alertContext, ta),
    );
  }
};
export const exportElementAsPNG = (
  ta: TransitionType,
  el: HTMLElement,
  filename: string,
  after?: Function,
  success?: Function,
  failed?: Function,
) => {
  toPng(el).then((image) => {
    if (Capacitor.isNativePlatform()) {
      shareBase64(ta, image, filename); //, success, failed);
    } else {
      const link = window.document.createElement("a");
      link.style = "display:none;";
      link.download = filename + ".png";
      link.href = image;
      link.click();
      if (after) {
        after();
      }
    }
  });
};
